// AUTO-GENERATED by tools/design-tokens/generate-css-refs.ts -- do not edit.
// Regenerate: npm run generate:derived-artifacts (or any typecheck/vitest run -- both ensure it)

/** Border radius tokens */
export const borderRadius = {
	none: "var(--radius-none)",
	xs: "var(--radius-xs)",
	sm: "var(--radius-sm)",
	DEFAULT: "var(--radius-default)",
	md: "var(--radius-md)",
	lg: "var(--radius-lg)",
	"2lg": "var(--radius-2lg)",
	xl: "var(--radius-xl)",
	"2xl": "var(--radius-2xl)",
	"3xl": "var(--radius-3xl)",
	full: "var(--radius-full)",
	shapes: {
		tag: "var(--radius-shapes-tag)",
		button: "var(--radius-shapes-button)",
		card: "var(--radius-shapes-card)",
	},
} as const;

/** Border width tokens */
export const borderWidth = {
	"0": "var(--border-width-0)",
	"2": "var(--border-width-2)",
	"4": "var(--border-width-4)",
	"8": "var(--border-width-8)",
	DEFAULT: "var(--border-width-default)",
} as const;

/** Box shadow tokens */
export const boxShadow = {
	xs: "var(--shadow-xs)",
	sm: "var(--shadow-sm)",
	DEFAULT: "var(--shadow-default)",
	md: "var(--shadow-md)",
	lg: "var(--shadow-lg)",
	xl: "var(--shadow-xl)",
	"2xl": "var(--shadow-2xl)",
	overlay: "var(--shadow-overlay)",
	none: "var(--shadow-none)",
	card: "var(--shadow-card)",
	glow: "var(--shadow-glow)",
} as const;

/** Glass morphism tokens */
export const glass = {
	backdropFilter: "var(--glass-backdrop-filter)",
} as const;

/** Motion/animation tokens */
export const motion = {
	easing: {
		standard: "var(--ease-standard)",
		emphasized: "var(--ease-emphasized)",
		linear: "var(--ease-linear)",
		spring: "var(--ease-spring)",
		smooth: "var(--ease-smooth)",
	},
	duration: {
		fastest: "var(--duration-fastest)",
		fast: "var(--duration-fast)",
		medium: "var(--duration-medium)",
		base: "var(--duration-base)",
		slow: "var(--duration-slow)",
		slower: "var(--duration-slower)",
		slowest: "var(--duration-slowest)",
		normal: "var(--duration-normal)",
	},
} as const;

/** Opacity tokens */
export const opacity = {
	transparent: "var(--opacity-transparent)",
	minimal: "var(--opacity-minimal)",
	subtle: "var(--opacity-subtle)",
	light: "var(--opacity-light)",
	muted: "var(--opacity-muted)",
	medium: "var(--opacity-medium)",
	semiTransparent: "var(--opacity-semi-transparent)",
	strong: "var(--opacity-strong)",
	veryStrong: "var(--opacity-very-strong)",
	nearOpaque: "var(--opacity-near-opaque)",
	opaque: "var(--opacity-opaque)",
	hover: "var(--opacity-hover)",
	active: "var(--opacity-active)",
	loading: "var(--opacity-loading)",
	overlay: "var(--opacity-overlay)",
	backdrop: "var(--opacity-backdrop)",
} as const;

/** Z-index tokens */
export const zIndex = {
	base: "var(--z-base)",
	raised: "var(--z-raised)",
	chip: "var(--z-chip)",
	surface: "var(--z-surface)",
	surfaceOverlay: "var(--z-surface-overlay)",
	floatingBackdrop: "var(--z-floating-backdrop)",
	floating: "var(--z-floating)",
	floatingRaised: "var(--z-floating-raised)",
	floatingRaisedMax: "var(--z-floating-raised-max)",
	affix: "var(--z-affix)",
	backTop: "var(--z-back-top)",
	dropdown: "var(--z-dropdown)",
	dropdownRaised: "var(--z-dropdown-raised)",
	dropdownMax: "var(--z-dropdown-max)",
	sticky: "var(--z-sticky)",
	fixed: "var(--z-fixed)",
	modalBackdrop: "var(--z-modal-backdrop)",
	modal: "var(--z-modal)",
	popover: "var(--z-popover)",
	toast: "var(--z-toast)",
	tooltip: "var(--z-tooltip)",
	loadingOverlay: "var(--z-loading-overlay)",
	devTools: "var(--z-dev-tools)",
	max: "var(--z-max)",
	overlayMax: "var(--z-overlay-max)",
} as const;
